import type { IntlService } from 'ember-intl';
import type { TReorderStrategy } from 'volta/models/types/planning-settings';

export const ReorderStrategies: Record<TReorderStrategy, string> = {
  MTS: 'reorderStrategies.MTS',
  MTO: 'reorderStrategies.MTO'
};

export const ReorderStrategiesOptions = Object.keys(ReorderStrategies).map(
  (key) => {
    return { key, label: ReorderStrategies[key as TReorderStrategy] };
  }
);

export const ReorderStrategiesArray: TReorderStrategy[] = Object.keys(
  ReorderStrategies
) as TReorderStrategy[];

export const translatedOptions = (intl: IntlService) =>
  ReorderStrategiesOptions.map((o) => ({ ...o, label: intl.t(o.label) }));

export default ReorderStrategies;
